import React, { useLayoutEffect, useRef } from 'react';

/** Break the right border and shadow without cutting into the card's fill.
 * Content is never clipped, so rails and avatar popovers remain independent. */
export function branchCardClip(centres: number[], width: number, height: number): string {
  if (!centres.length) return 'none';
  const openings: [number, number][] = [];
  for (const centre of [...centres].sort((a, b) => a - b)) {
    const previous = openings.at(-1);
    if (previous && centre - 10 <= previous[1]) previous[1] = centre + 10;
    else openings.push([centre - 10, centre + 10]);
  }
  const outside = width + 12, inside = width - 2;
  const path = [`M -12 -12 L ${outside} -12`];
  for (const [top, bottom] of openings) {
    path.push(`L ${outside} ${top} L ${inside + 4} ${top} Q ${inside} ${top} ${inside} ${top + 4}`,
      `L ${inside} ${bottom - 4} Q ${inside} ${bottom} ${inside + 4} ${bottom} L ${outside} ${bottom}`);
  }
  path.push(`L ${outside} ${height + 12} L -12 ${height + 12}`);
  path.push('Z');
  return `path("${path.join(' ')}")`;
}

export function ItineraryDestinationCard({ id, excluded, children }: {
  id?: string; excluded: boolean; children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const card = ref.current!;
    const junctions = [...card.querySelectorAll<HTMLElement>('.itinerary-branch-junction-inset')];
    const update = () => {
      const { top, width, height } = card.getBoundingClientRect();
      card.style.setProperty('--branch-card-clip', branchCardClip(junctions.map(row => {
        const bounds = row.getBoundingClientRect();
        return bounds.top - top + bounds.height / 2;
      }), width, height));
    };
    update();
    if (!junctions.length) return;
    const observer = new ResizeObserver(update);
    observer.observe(card);
    [...card.children].forEach(child => observer.observe(child));
    return () => observer.disconnect();
  }, [children]);
  return <div ref={ref} id={id} data-excluded={excluded || undefined}
    className="surface-solid itinerary-destination-card relative isolate rounded-2xl border border-transparent p-4 space-y-3">{children}</div>;
}
